import React from 'react';
import './Footer.css';

export default function Footer(){
    return(
        <div className='footer'> 
        <p className='credits'>
          Made with &#9829; by group 13
        </p>
        </div>
    )
}